
import { Options, Vue } from 'vue-class-component'
import axios from 'axios'

@Options({
  components: {
  },
})
export default class weather extends Vue {
    api_key = 'c0367ef24e5208a71b5782d87e7f65b0'
    url_base = 'https://api.openweathermap.org/data/2.5/'
    city = ''
    weather = {
        name: '',
        country: '',
        temp: 0,
        weather: '',
        desc: ''
    }
    cityFound = false
    visible = true
    d = new Date()
    months = ["January","February","March","April","May","June","July","August","September","October","November","December"]
    weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]
    month = this.months[this.d.getMonth()]
    day = this.weekday[this.d.getDay()]
    year = this.d.getFullYear()
    date = this.d.getDate()
    currentDate = `${this.day}, ${this.date} ${this.month} ${this.year}`

    getWeather(){
        axios.get(`${this.url_base}weather?q=${this.city}&units=metric&appid=${this.api_key}`)
        .then((res) => {
            // console.log(res.data, 'comparing the data to the data object', this.weather)
             this.weather.name = res.data.name
             this.weather.country = res.data.sys.country
             this.weather.temp = Math.round(res.data.main.temp)
             this.weather.weather = res.data.weather[0].main
             this.weather.desc = res.data.weather[0].description
             this.city = ''
        }).catch((err) => {
            console.log(err);
            this.cityFound = true
            this.city = ''
            this.visible = false
            setTimeout(() => {    
                this.cityFound = false     
                this.visible = true
            },3000) 
          })
    }

    mounted(){
        axios.get(`${this.url_base}weather?q=Lagos&units=metric&appid=${this.api_key}`)
        .then((res) => {
             this.weather.name = res.data.name
             this.weather.country = res.data.sys.country
             this.weather.temp = Math.round(res.data.main.temp)
             this.weather.weather = res.data.weather[0].main
             this.weather.desc = res.data.weather[0].description
        })
    }
}
